(function () {
    'use strict';

    angular.module("handbookApp")
        .controller(controllers.searchController, searchController);

    searchController.$inject = ['$scope', '$http', '$state', '$stateParams', '$timeout', '$document',
        'favoriteService', 'folderService', 'tabStateService', 'resizeService', 'stringValidationService',
        'metaDataService', 'documentService', '$location', '$q', 'configService', 'broadcastService', '$filter'];

    function searchController($scope, $http, $state, $stateParams, $timeout, $document,
        favoriteService, folderService, tabStateService, resizeService, stringValidationService,
        metaDataService, documentService, $location, $q, configService, broadcastService, $filter) {
        var vm = this;
        vm.handbookRequests = handbookRequests;
        $scope.translation = globalResources;
        vm.commonGridSettingKey = gridSettingKeys.commonVisibilitySettings;
        vm.enabledMetadataSearch = true;
        vm.enabledAdvanceSearch = true;
        vm.isMetadataSearch = configService.getBool(HandbookConfiguration.MetadataEnabled) && vm.enabledMetadataSearch;
        vm.doSearchDataMining = configService.getBool(HandbookConfiguration.DoSearchDataMining);
        vm.enabledCompendiaSearch = configService.getBool(HandbookConfiguration.CompendiaSearch);
        vm.searchInFolders = configService.getBool(HandbookConfiguration.SearchInFolders);
        var showCompendiaSearch = vm.enabledCompendiaSearch;
        var showFolderSearch = vm.searchInFolders;

        vm.searchLogLevel = parseInt(HandbookConfiguration.SearchLogLevel);
        $scope.searchTypes = [
            { id: 1, name: $scope.translation.TitleSearch },
            { id: 2, name: $scope.translation.ContentSearch }
        ];
        if (vm.enabledAdvanceSearch) {
            $scope.searchTypes.push({ id: 3, name: $scope.translation.AdvanceSearch });
        }
        if (vm.isMetadataSearch) {
            $scope.searchTypes.push({ id: 4, name: $scope.translation.MetadataSearch });
        }

        $scope.keywords = {};
        vm.today = new Date();

        vm.keyword = $stateParams.keyword;
        vm.searchInContents = $stateParams.searchInContents == true || $stateParams.searchInContents == 'true';

        vm.folderId = $stateParams.folderId;
        vm.fromDate = $stateParams.fromDate != null ? new Date(parseInt($stateParams.fromDate)) : null;
        vm.fromDateBK = angular.copy(vm.fromDate);
        vm.toDate = $stateParams.toDate != null ? new Date(parseInt($stateParams.toDate)) : null;
        vm.toDateBK = angular.copy(vm.toDate);
        vm.fromDateDisplayed = $stateParams.fromDate != null ? new Date(parseInt($stateParams.fromDate)) : null;
        vm.toDateDisplayed = $stateParams.toDate != null ? new Date(parseInt($stateParams.toDate)) : null;
        vm.registerItemId = $stateParams.registerItemId;
        vm.registerItemValueId = $stateParams.registerItemValueId;
        vm.type = $stateParams.type;
        vm.hasExpired = $stateParams.hasExpired == 1;
        vm.version = $stateParams.version != null ? parseInt($stateParams.version) : null;
        vm.documentType = $stateParams.documentType != null ? parseInt($stateParams.documentType) : null;
        vm.advancedSearchLocationType = vm.folderId == null ? 1 : (isNaN(vm.folderId) ? 2 : 1);

        vm.documents = {};
        vm.folders = {};
        vm.compendiaDocuments = [];
        vm.totalHits = 0;
        vm.totalFound = 0;
        vm.showLoadMore = false;
        vm.loadMoreClickedCounter = 0;
        vm.searchFilter = '';
        vm.folderName = '';
        vm.searchType = E.searchType.Maximum;
        vm.searchFilters = '';
        vm.showMoreLink = globalResources.Showmore;

        vm.selectedItem = {
            selectedMetadata: null,
            selectedTag: null
        };

        vm.foldersGridSetting = [];

        vm.initMetadata = {
            metadatas: [],
            tags: []
        };

        vm.startMetadata = 0;
        vm.startTag = 0;

        vm.onRowClick = onRowClick;
        vm.loadByMaxSearchSize = loadByMaxSearchSize;
        vm.showLoadMoreLink = showLoadMoreLink;
        $scope.selectNodeHead = selectNodeHead;
        $scope.selectNodeLabel = selectNodeLabel;
        $scope.clearSelectedNode = clearSelectedNode;
        $scope.clearFromDate = clearFromDate;
        $scope.clearToDate = clearToDate;
        $scope.changeSearchType = changeSearchType;
        $scope.setSearchLocationType = setSearchLocationType;
        $scope.search = search;
        $scope.isProcessNode = isProcessNode;
        vm.openCompendiaDocument = openCompendiaDocument;
        vm.defaultExportFileName = globalResources.SearchResult;
        vm.openDocument = openDocument;
        vm.folderClick = folderClick;
        vm.onVARClick = onVARClick;

        vm.isClickDocument = false;

        vm.areaGridSetting = [];
        vm.processes = {};
        vm.processAreas = {};
        vm.processesInterconnected = {};
        vm.areasRecords = 0;
        vm.processRecords = 0;
        vm.goToProcess = goToProcess;
        vm.goToProcessArea = goToProcessArea;
        vm.goToProcessInterconnected = goToProcessInterconnected;
        vm.enableProcess = configService.getBool(HandbookConfiguration.EnableProcess);
        vm.enableVAR = configService.getBool(HandbookConfiguration.EnableVAR);
        vm.enableInterconnectedProcess = configService.getBool(HandbookConfiguration.InterconnectedProcess);

        vm.maxHeight = 635;
        vm.getGetRegisterItemByAreaOrFolder = getGetRegisterItemByAreaOrFolder;
        vm.metaDataAll = [];
        vm.VAROffset = 0;

        vm.VARsGridSetting = [
            { id: 'title', name: window.resources.L.Common.title, width: 33, coldefault: true },
            { id: 'status', name: window.resources.L.Common.changeType, width: 33, coldefault: true },
            { id: 'updatedDate', name: window.resources.L.Common.lastUpdated, width: 33, coldefault: true }
        ];

        vm.varRecords = [];

        vm.exportParams = {};
        vm.exportRequestUrl = '';
        vm.exportDocumentParams = {};
        vm.searchProcessParams = {};
        vm.exportProcessParams = {};
        vm.exportProcessInterconnectedParams = {};
        vm.tabNameToExport = { processTab: 'processTab', interconnectedTab: 'interconnectedTab', documentTab: 'documentTab', areaTab: 'areaTab', folderTab: 'folderTab' };
        vm.handleChangeTabForExportList = handleChangeTabForExportList;
        vm.enableExportButton = false;

        initialize();

        function initialize() {
            //check and resize the view
            if (vm.isMetadataSearch) {
                getRegisterItems();
            }
            if (vm.searchInFolders) {
                buildFoldersGridSetting();
            }
            buildAreaGridSetting();
            loadFolderTree();

            if (vm.enableProcess) {
                loadAreaTree();
            }

            resizeService.resizeView();

            getGridSetting(gridSettingKeys.commonVisibilitySettings);
            getColumnsDefinition(gridSettingKeys.commonVisibilitySettings);
            vm.getFolderInformation = getFolderInformation();

            vm.commonColumnsDefinition = angular.copy(optionalColumnsDenifinition);
            //TODO Why do we use these 2 lines?
            /*$scope.commonGridColumnDefinition = commonColumnsDefinition;
            $scope.optionalColumns = optionalColumnsDenifinition;*/

            generateExportParams();

            if (vm.enabledCompendiaSearch) { 
                var mandatatoryRequests = [
                    searchCompendiaDocuments(vm.keyword),
                    getSearchResult(E.searchType.Maximum)
                ];

                $q.all(mandatatoryRequests).then(function (response) {
                    $timeout(function () {
                        handleNavigate();
                    }, 500);
                    getExportParams();
                });
            } else {
                var mandatatoryRequests = [getSearchResult(E.searchType.Maximum, true)];
                $q.all(mandatatoryRequests).then(function (response) {
                    getExportParams();
                });
            }

            activeButtonGroup(parseInt(vm.type), true);
            activeLocationTypeButtonGroup(vm.advancedSearchLocationType);
            
            if (vm.folderId) {
                getGetRegisterItemByAreaOrFolder(vm.folderId);
            }
            watchVARGridScroll();
        };

        $scope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams, options) {
                if (vm.isClickDocument
                    || vm.searchLogLevel != SEARCH_LOG_LEVEL.LOG_DOCUMENT_SELECTED_AND_0_HIT_AND_NO_SELECTION
                    || fromState.name != "searchDocuments" || vm.documents.length == 0 || vm.documents.length == undefined
                    || vm.documents == null) {
                    vm.isClickDocument = false;
                    return;
                }
                else {
                    insertLogWords(-2, user.userId, vm.keyword, $scope.selectedSearchType.id);
                }
                vm.isClickDocument = false;

            });

        function folderClick(id) {
            favoriteService.setFavoriteNodeState({ isFavorited: false });
            $state.go(handbookActions.FolderAction, { folderId: id });
        };

        function goToProcess(processNumber) {
            $state.go('process-detail', { processNumber: processNumber });
        }

        function goToProcessArea(areaId) {
            $state.go('process-area-detail', { areaId: areaId });
        }

        function goToProcessInterconnected(processInterconnectedNumber) {
            $state.go('process-interconnected', { processNumber: processInterconnectedNumber });
        }

        function handleNavigate() {
            var url = angular.copy($location.$$url);
            if (!url)
                return;
            url = url.toLowerCase();

            if (url.indexOf('tab?') == -1) {
                return;
            }

            if (vm.processes.length > 0 && url.indexOf('searchProcesses') > -1) {
                triggerTabClicked('#seachProcesses', false);
            }

            if (vm.documents.length > 0 && url.indexOf('searchDocuments') > -1) {
                triggerTabClicked('#searchDocuments', false);
            }

            if (vm.processAreas.length > 0 && url.indexOf('searchProcessAreas') > -1) {
                triggerTabClicked('#searchProcessAreas', false);
            }

            if (vm.folders.length > 0 && url.indexOf('searchFolders') > -1) {
                triggerTabClicked('#searchFolders', false);
            }

            if (vm.processesInterconnected.length > 0 && url.indexOf('seachProcessesInterconnected') > -1) {
                triggerTabClicked('#seachProcessesInterconnected', false);
            }

            if (vm.varRecords.length > 0 && url.indexOf('searchVAR') > -1) {
                triggerTabClicked('#searchVAR', false);
            }
        }

        function triggerTabClicked(tabId, clickItSelf) {
            setTimeout(function () {
                var childTab = $(tabId + ' a');
                if (childTab) {
                    $(childTab).click();
                    if (clickItSelf && $(tabId)) {
                        $(tabId).click();
                    }
                }
            });
        }

        function buildFoldersGridSetting() {
            vm.foldersGridSetting.push({ id: 'name', name: globalResources.Folder, width: 50, coldefault: true, icon: 'icon' });
            vm.foldersGridSetting.push({ id: 'location', name: globalResources.CommonGridColumns.Location, width: 50, coldefault: true });
            vm.columnNotRemove = 'name';
        }

        function buildAreaGridSetting() {
            vm.areaGridSetting.push({ id: 'name', name: globalResources.ProcessArea, width: 50, coldefault: true, icon: 'icon' });
            vm.areaGridSetting.push({ id: 'location', name: globalResources.CommonGridColumns.Location, width: 50, coldefault: true });
            vm.columnNotRemove = 'name';
        }

        function openDocument(id) {
            vm.isClickDocument = true;
            insertLogWords(id, user.userId, vm.keyword, $scope.selectedSearchType.id);
        }

        $scope.$on(broadcastType.gridSettingTarget, function (e, target, gridSettingKey) {
            if (gridSettingKey == gridSettingKeys.commonVisibilitySettings) {
                vm.exportDocumentParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Document);
                vm.exportProcessParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Process);
                vm.exportProcessInterconnectedParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.InterconnectedProcess);
            }
        });

        $document.bind('click', function (event) {
            var isClickedElementChildOfPopup = $('.folder-search')
                .find(event.target)
                .length > 0;

            if (isClickedElementChildOfPopup)
                return;
            $scope.showFolderTree = false;
        });

        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            adjustContentPosition();
        });

        function adjustContentPosition() {
            var tabState = tabStateService.getState(tabStateType.searchTabState);
            $timeout(function () {
                tabStateService.adjustContentPosition(tabState, tabStateType.searchTabState);
            }, 0, false);
        }

        function getRegisterItems() {
            if (vm.isMetadataSearch) {
                if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.processArea)) {
                    $http.get('/api/qmsMetaData/GetRegisterAndRegisterItemsForModule', { params: { application: 200 } })
                        .then(function (response) {
                            if (response && response.data) {
                                if (!vm.folderId) {
                                    vm.initMetadata.metadatas = response.data;
                                }
                                vm.metaDataAll = response.data;
                            }
                        })
                }
                else {
                    metaDataService.getRegisterAndRegisterItems().then(function (data) {
                        if (data) {
                            if (!vm.folderId) {
                                vm.initMetadata.metadatas = data;
                            }
                            vm.metaDataAll = data;
                        }
                    });
                }

            }
        };

        $scope.$watch('vm.selectedItem.selectedMetadata', function (selectedMetadata) {
            if (selectedMetadata) {
                vm.registerItemId = selectedMetadata.registerItemId;
                vm.selectedItem.selectedMetadata = vm.initMetadata.metadatas.find((x) => x.registerItemId == vm.registerItemId);
            }
            if (vm.registerItemId) {
                vm.selectedItem.selectedMetadata = vm.initMetadata.metadatas.find((x) => x.registerItemId == vm.registerItemId);
            }
            
            if (vm.isMetadataSearch) {
                if (vm.startTag != 1) {
                    vm.selectedItem.selectedTag = null;
                    if (selectedMetadata != null && selectedMetadata != undefined) {
                        getMetadataTags(selectedMetadata.registerItemId);
                    }
                } else {
                    vm.startTag = 0;
                }
            }
        });

        function getMetadataTags(registerItemId) {
            if (vm.isMetadataSearch) {
                metaDataService.getMetadataTags(registerItemId).then(function (data) {
                    if (data) {
                        vm.initMetadata.tags = data;
                    }
                });
            }
        };

        function isProcessNode(node) {
            return isNaN(node.id);
        }

        function selectNodeHead(node) {
            if (!node.isLoaded && vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.folder)) {
                $http.get(handbookRequests.GetSubfoldersRequest, { params: { 'folderId': node.id } })
                    .success(function (data, status, headers, config) {
                        node.children = data;
                        node.isLoaded = true;
                    })
                    .error(function (data, status, headers, config) {
                        node.isLoaded = true;
                    });
            }
            else if (!node.isLoaded && vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.processArea)) {
                $http.get('/api/ProcessAreas/GetContent', { params: { AreaId: node.id, ShowProcessesInTree: false, IsOnlyApproved: false } })
                    .success(function (data, status, headers, config) {
                        node.children = data.areas;
                        node.isLoaded = true;
                    })
                    .error(function (data, status, headers, config) {
                        node.isLoaded = true;
                    });
            }
        };

        function selectNodeLabel(node) {
            getGetRegisterItemByAreaOrFolder(node.id);
            $scope.selectedNode = node;
            $scope.showFolderTree = false;
        };

        function getGetRegisterItemByAreaOrFolder(id) {
            if (!id || !vm.isMetadataSearch || (vm.advancedSearchLocationType !== parseInt(E.advancedSearchLocationType.folder) && vm.advancedSearchLocationType !== parseInt(E.advancedSearchLocationType.processArea))) {
                return;
            }
            if (vm.advancedSearchLocationType == E.advancedSearchLocationType.folder) {
                getRegisterItemsByModule(id);
            }
            else {
                getRegisterItemOfArea(id);
            };
           
        }

        function getRegisterItemsByModule(id) {
            $http.get('/api/qmsMetaData/GetRegisterItemsByModule', { params: { folderId: id, application: 136 } })
                .then(function (response) {
                    if (response && response.data) {
                        vm.initMetadata.metadatas = response.data;
                        vm.initMetadata.metadatas.forEach((item) => {
                            var metaDataItem = vm.metaDataAll.find((x) => x.registerItemId == item.registerItemId);
                            item.name = metaDataItem.name;
                        });

                    }
                })
        }

        function getRegisterItemOfArea(id) {
            $http.get('/api/qmsMetaData/GetRegisterItemOfArea', { params: { areaId: id } })
                .then(function (response) {
                    if (response && response.data) {
                        vm.initMetadata.metadatas = response.data;
                        vm.initMetadata.metadatas.forEach((item) => {
                            var metaDataItem = vm.metaDataAll.find((x) => x.registerItemId == item.registerItemId);
                            item.name = metaDataItem.name;
                        });
                    }
                })
        }

        function clearSelectedNode() {
            $scope.selectedNode = null;
            vm.initMetadata.metadatas = vm.metaDataAll;
            if (vm.registerItemId) {
                vm.selectedItem.selectedMetadata = vm.initMetadata.metadatas.find((x) => x.registerItemId == vm.registerItemId);
            };
            //getRegisterItems();
        }

        function clearFromDate() {
            $scope.fromDate = null;
        }

        function clearToDate() {
            $scope.toDate = null;
        }

        function activeButtonGroup(type, notCalculateHeigthGrid) {
            angular.element('#search-title-id').addClass('btn-disabled');
            angular.element('#search-content-id').addClass('btn-disabled');
            angular.element('#search-advance-id').addClass('btn-disabled');
            angular.element('#search-metadata-id').addClass('btn-disabled');
            if (type == 1) {
                angular.element('#search-title-id').removeClass('btn-disabled');
                $scope.selectedSearchType = $scope.searchTypes[0];
            } else if (type == 2) {
                angular.element('#search-content-id').removeClass('btn-disabled');
                $scope.selectedSearchType = $scope.searchTypes[1];
            } else if (type == 3) {
                angular.element('#search-advance-id').removeClass('btn-disabled');
                $scope.selectedSearchType = $scope.searchTypes[2];
            } else if (type == 4) {
                angular.element('#search-metadata-id').removeClass('btn-disabled');
                $scope.selectedSearchType = $scope.searchTypes[3];
            }

            var showMoreItem = (type == 3 || type == 4);
            if (!notCalculateHeigthGrid) {
                setHeightForGrid();
            }
        }

        function changeSearchType(type) {
            if (type == parseInt(E.searchTypeHandbook.titleSearch)) {
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = false;
                $scope.searchPlaceHolder = $scope.translation.TitleSearch;
                $scope.selectedSearchType = $scope.searchTypes[0];
            } else if (type == parseInt(E.searchTypeHandbook.contentSearch)) {
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = false;
                $scope.searchPlaceHolder = $scope.translation.ContentSearch;
                $scope.selectedSearchType = $scope.searchTypes[1];
            }
            else if (type == parseInt(E.searchTypeHandbook.advancedSearch) && vm.enabledAdvanceSearch) {
                $scope.isAdvanceSearch = true;
                $scope.isMetadataSearch = false;
                $scope.searchPlaceHolder = $scope.translation.AdvanceSearch;
                $scope.selectedSearchType = $scope.searchTypes[2];
                activeLocationTypeButtonGroup(vm.advancedSearchLocationType);
            } else if (type == parseInt(E.searchTypeHandbook.metadataSearch) && vm.enabledMetadataSearch) {
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = true;
                $scope.searchPlaceHolder = $scope.translation.MetadataSearch;
                $scope.selectedSearchType = $scope.searchTypes[3];
                activeLocationTypeButtonGroup(vm.advancedSearchLocationType);
                getGetRegisterItemByAreaOrFolder(vm.folderId);
            }
            setHeightForGrid();

            $timeout(function () {
                activeButtonGroup(type);
            }, 500);
        }

        function activeLocationTypeButtonGroup(type) {
            angular.element('#search-folder-id').addClass('label-btn-disabled');
            angular.element('#search-process-area-id').addClass('label-btn-disabled');
            if (type == 1) {
                angular.element('#search-folder-id').removeClass('label-btn-disabled');
            } else if (type == 2) {
                angular.element('#search-process-area-id').removeClass('label-btn-disabled');
            }
        }

        function setSearchLocationType(type) {
            vm.advancedSearchLocationType = type;
            clearSelectedNode();
            if (vm.isMetadataSearch) {
                getRegisterItems();
            }
            activeLocationTypeButtonGroup(type);
        }

        function search() {
            if ($scope.selectedSearchType.id == E.searchTypeHandbook.titleSearch) {
                searchTitle();
            } else if ($scope.selectedSearchType.id == E.searchTypeHandbook.contentSearch) {
                searchContent();
            } else if ($scope.selectedSearchType.id == E.searchTypeHandbook.advancedSearch) {
                searchAdvance();
            } else if ($scope.selectedSearchType.id == E.searchTypeHandbook.metadataSearch) {
                searchMetadata();
            }

            var searchCondition = ((vm.keyword != null && vm.keyword != "")
                || vm.folderId != ''
                || vm.fromDate != null
                || vm.toDate != null
                || (vm.registerItemId != null && vm.registerItemId != undefined && vm.registerItemId != 0))
                && stringValidationService.notContainSpecialCharacter(vm.keyword);
            if (!searchCondition) {
                return;
            }
            $state.go(handbookActions.SearchResultAction, {
                keyword: vm.keyword,
                searchInContents: vm.searchInContents ? 1 : 0,
                folderId: vm.folderId,
                fromDate: vm.fromDate,
                toDate: vm.toDate,
                hasExpired: vm.hasExpired ? 1 : 0,
                registerItemId: vm.registerItemId,
                registerItemValueId: vm.registerItemValueId,
                type: $scope.selectedSearchType.id
            });
        }

        function openCompendiaDocument(link) {
            window.open(link);
        }

        function searchTitle() {
            vm.keyword = $scope.keyword;
            vm.searchInContents = false;
            vm.folderId = null;
            vm.fromDate = null;
            vm.toDate = null;
            vm.hasExpired = false;
            vm.registerItemId = null;
            vm.registerItemValueId = null;
        }

        function searchContent() {
            vm.keyword = $scope.keyword;
            vm.searchInContents = true;
            vm.folderId = null;
            vm.fromDate = null;
            vm.toDate = null;
            vm.hasExpired = false;
            vm.registerItemId = null;
            vm.registerItemValueId = null;
        }

        function searchAdvance() {
            vm.keyword = $scope.keyword;
            vm.searchInContents = true;
            vm.folderId = $scope.selectedNode != null ? $scope.selectedNode.id : null;
            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;

            vm.fromDate = ($scope.fromDate != null && ($scope.toDate == null || $scope.fromDate <= $scope.toDate)) ? $scope.fromDate.getTime() : null;
            vm.toDate = ($scope.toDate != null && $scope.toDate <= vm.today) ? $scope.toDate.getTime() : null;
            vm.hasExpired = $scope.hasExpired;
            vm.registerItemId = null;
            vm.registerItemValueId = null;
        }

        function searchMetadata() {
            vm.keyword = $scope.keyword;
            vm.searchInContents = true;
            vm.folderId = $scope.selectedNode != null ? $scope.selectedNode.id : null;
            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;
            vm.fromDate = null;
            vm.toDate = null;
            vm.hasExpired = false;
            vm.registerItemId = vm.selectedItem.selectedMetadata != null ? vm.selectedItem.selectedMetadata.registerItemId : null;
            vm.registerItemValueId = vm.selectedItem.selectedTag != null ? vm.selectedItem.selectedTag.registerItemValueId : null;
        }

        function getSearchResult(searchType, reCalculateHeigth) {
            const quickSearchKeyword = vm.keyword ? vm.keyword.trim() : '';
            if (!quickSearchKeyword && (vm.type != parseInt(E.searchTypeHandbook.advancedSearch) && vm.type != parseInt(E.searchTypeHandbook.metadataSearch))) {
                return;
            }

            if (vm.enableProcess) {
                triggerSearchProcessModule(searchType);
            }

            if (vm.enableVAR) {
                triggerSearchVAR(quickSearchKeyword, vm.VAROffset);
            }

            var searchCondition = ((vm.keyword != null && vm.keyword != "")
                || vm.folderId != ''
                || vm.fromDate != null
                || vm.toDate != null
                || (vm.registerItemId != null && vm.registerItemId != undefined && vm.registerItemId != 0))
                && stringValidationService.notContainSpecialCharacter(vm.keyword);

            if (!searchCondition) {
                vm.searchConditionTrue = false;
                return;
            }

            vm.searchConditionTrue = true;

            vm.totalHits = specialCharacter.questionMark;
            vm.totalFound = specialCharacter.questionMark;

            if (vm.fromDate != null && typeof vm.fromDate != 'string') {
                vm.fromDate = vm.fromDate.toLocaleDateString() + ' GMT';
            }
            if (vm.toDate != null && typeof vm.toDate != 'string') {
                vm.toDate = vm.toDate.toLocaleDateString() + ' GMT';
            }
            if (vm.registerItemId) {
                vm.searchInContents = true;
            }

            var searchRequestParams = {
                keyword: vm.keyword,
                searchInContents: vm.searchInContents,
                searchType: searchType,
                folderId: vm.folderId,
                fromDate: vm.fromDate,
                toDate: vm.toDate,
                hasExpired: vm.hasExpired,
                registerItemId: vm.registerItemValueId != null ? null : vm.registerItemId,
                registerItemValueId: vm.registerItemValueId,
                version: vm.version,
                documentType: vm.documentType,
                searchFilters: vm.searchParams,
                showLoading: true,
            };

            vm.searchType = searchType;

            tabStateService.setCurrentStateType(tabStateType.searchTabState);

            if (isGuid(vm.folderId)) {
                return;
            }

            return $http.get(handbookRequests.SearchRequest, { params: searchRequestParams })
                .then(function (response, status, headers, config) {
                    if (response.data.documents != null && (response.data.documents.length > 0)) {
                        updateAttachmentsForDocuments(response.data.documents);
                        documentService.getAgreeFilesForDocuments(response.data.documents);
                        vm.documents = response.data.documents.filter(x => !x.hidden);
                        vm.totalHits = vm.documents.length;
                        vm.totalFound = response.data.totalCount;
                        var showMoreItem = (vm.type == parseInt(E.searchTypeHandbook.contentSearch) || vm.type == parseInt(E.searchTypeHandbook.metadataSearch));
                    } else {
                        vm.totalHits = 0;
                        vm.totalFound = 0;
                        if (vm.searchLogLevel == SEARCH_LOG_LEVEL.LOG_DOCUMENT_SELECTED_AND_0_HIT
                            || vm.searchLogLevel == SEARCH_LOG_LEVEL.LOG_DOCUMENT_SELECTED_AND_0_HIT_AND_NO_SELECTION) {
                            insertLogWords(-1, user.userId, vm.keyword, $scope.selectedSearchType.id);
                        }
                    }
                    if (response.data.folders != null && response.data.folders.length > 0 && (vm.type != parseInt(E.searchTypeHandbook.advancedSearch) && vm.type != parseInt(E.searchTypeHandbook.metadataSearch))) {
                        vm.folders = response.data.folders.filter(x => !x.hidden);
                        angular.forEach(vm.folders, function (node) {
                            node.icon = getFolderClass(node.type)
                        });
                        vm.totalFolderHits = vm.folders.length;
                    }
                    showFolderSearch = (showFolderSearch && vm.folders.length > 0 || vm.processAreas.length > 0);
                    if (reCalculateHeigth) {
                        $timeout(function () {
                            setHeightForGrid();
                        }, 200);
                    }
                });
        }

        function triggerSearchProcessModule(searchType) {
            if (vm.type != parseInt(E.searchTypeHandbook.advancedSearch) && vm.type != parseInt(E.searchTypeHandbook.metadataSearch)) {
                getProcessAreaSearchResult(searchType);
                getProcessSearchResult(searchType);
                if (vm.enableInterconnectedProcess) {
                    getProcessInterconnectedSearchResult(searchType);
                }
                return;
            }

            if (vm.folderId == null || isNaN(vm.folderId)) {
                advancedSearchProcess(vm.keyword, searchType)
                if (vm.enableInterconnectedProcess) {
                    advancedSearchProcessInterconnected(vm.keyword, searchType);
                }

                return;
            }
        }

        function advancedSearchProcess(keyword, searchType) {
            let searchParams = generateSearchProcessAdvanceParams(keyword, searchType);

            return $http.get(handbookRequests.SearchProcessesAdvance, { params: searchParams })
                .success(function (response) {
                    if (response != null && response.length) {
                        updateAttachmentsForProcesses(response);
                        vm.processes = response;
                        vm.processes = vm.processes.map(ele => {
                            ele.handbookId = ele.folderId;
                            return ele;
                        });
                        angular.forEach(vm.folders, function (node) {
                            node.icon = getFolderClass(node.type)
                        });
                        vm.processRecords = vm.processes.length;
                    }
                })
                .error(function (data, status, headers, config) {
                });
        }

        function advancedSearchProcessInterconnected(keyword, searchType) {
            let searchParams = generateSearchProcessAdvanceParams(keyword, searchType);

            return $http.get(handbookRequests.SearchProcessInterconnectedAdvance, { params: searchParams })
                .success(function (response) {
                    if (response != null && response.length) {
                        updateAttachmentsForProcessesInterconnected(response);
                        vm.processesInterconnected = response;
                        vm.processesInterconnected = vm.processesInterconnected.map(ele => {
                            ele.handbookId = ele.folderId;
                            return ele;
                        });
                        angular.forEach(vm.folders, function (node) {
                            node.icon = getFolderClass(node.type)
                        });
                    }
                })
                .error(function (data, status, headers, config) {
                });
        }

        function getProcessAreaSearchResult(searchType) {
            var processRequestParams = {
                keyword: vm.keyword ? vm.keyword : '',
                searchType: searchType,
                isFrontend: true,
                isContentSearch: vm.searchInContents
            };

            return $http.get(handbookRequests.SearchProcessAreas, { params: processRequestParams })
                .then(function (response) {
                    if (response != null && response.data != null && response.data.length) {
                        vm.processAreas = response.data;
                        angular.forEach(vm.processAreas, function (node) {
                            node.icon = 'fa fa-folder areas-color';
                        });
                        vm.areasRecords = vm.processAreas.length;
                    }
                });
        }

        function getProcessSearchResult(searchType) {
            var processRequestParams = generateSearchProcessParams(searchType);

            return $http.get(handbookRequests.SearchProcesses, { params: processRequestParams })
                .then(function (response) {
                    if (response != null && response.data != null && response.data.length) {
                        updateAttachmentsForProcesses(response.data);
                        vm.processes = response.data;
                        vm.processes = vm.processes.map(ele => {
                            ele.handbookId = ele.folderId;
                            return ele;
                        });
                        angular.forEach(vm.folders, function (node) {
                            node.icon = getFolderClass(node.type)
                        });
                        vm.processRecords = vm.processes.length;
                    }
                });
        }

        function getProcessInterconnectedSearchResult(searchType) {
            var processRequestParams = generateSearchProcessParams(searchType);

            return $http.get(handbookRequests.SearchProcessInterconnected, { params: processRequestParams })
                .then(function (response) {
                    if (response != null && response.data != null && response.data.length) {
                        updateAttachmentsForProcessesInterconnected(response.data);
                        vm.processesInterconnected = response.data;
                        vm.processesInterconnected = vm.processesInterconnected.map(ele => {
                            ele.handbookId = ele.folderId;
                            return ele;
                        });
                        angular.forEach(vm.folders, function (node) {
                            node.icon = getFolderClass(node.type)
                        });
                    }
                });
        }

        function getFolderClass(nodeType) {
            switch (nodeType.toString()) {
                case E.nodeTypes.Folder:
                    return 'folder-5-icon';
                case E.nodeTypes.TopFolder:
                    return 'folder-6-icon';
                case E.nodeTypes.DepartmentFolder:
                    return 'folder-7-icon';
                case E.nodeTypes.RegionalFolder:
                    return 'folder-8-icon';
                default:
                    return 'folder-5-icon';
            }
        };

        function searchCompendiaDocuments(keyword) {
            var searchUrl = null;
            if (vm.type == parseInt(E.searchTypeHandbook.titleSearch)) {
                searchUrl = handbookRequests.CompendiaDocument_TitleSearch;
            } else if (vm.type == parseInt(E.searchTypeHandbook.contentSearch)) {
                searchUrl = handbookRequests.CompendiaDocument_ContentSearch;
            }

            if (searchUrl == null) {
                vm.compendiaDocuments = [];
                return;
            }

            return $http.get(searchUrl, { params: { keyword: keyword, showLoading: true } })
                .success(function (data) {
                    vm.compendiaDocuments = data;
                    showCompendiaSearch = (showCompendiaSearch && vm.compendiaDocuments.length > 0);
                });
        }

        function getFolderInformation() {
            if (vm.folderId != undefined && vm.folderId != 0) {
                if (!isNaN(vm.folderId)) {
                    var folder = folderService.getFolder();
                    if (folder == undefined) {
                        folderService.getFolderById(vm.folderId).then(function (response) {
                            vm.folderName = response.data.name;
                            $scope.selectedNode = response.data;
                        });
                    }
                    else {
                        vm.folderName = folder.name;
                        $scope.selectedNode = folder;
                    }
                }
                else {
                    $http.get('/api/ProcessAreas/GetContent', { params: { AreaId: vm.folderId, ShowProcessesInTree: false, IsOnlyApproved: false } })
                        .success(function (data, status, headers, config) {
                            vm.folderName = data.areaInformation.name;
                            $scope.selectedNode = data.areaInformation;
                        });
                }

            }
        };

        function getSearchFilter() {
            var filter = '';
            if (vm.keyword != null && vm.keyword != '') {
                filter = vm.keyword;
            }
            var folderIdNotNull = vm.folderId != 0 && vm.folderId != null,
                fromDateNotNull = vm.fromDateDisplayed != null,
                toDateNotNull = vm.toDateDisplayed != null,
                registerItemIdNotNull = vm.selectedItem.selectedMetadata != null,
                registerItemValueIdNotNull = vm.selectedItem.selectedTag != null,
                startOption = specialCharacter.space + specialCharacter.openParenthesis,
                endOption = specialCharacter.closeParenthesis,
                seperator = specialCharacter.comma + specialCharacter.space,
                colon = specialCharacter.space + specialCharacter.colon + specialCharacter.space;
            if ($scope.selectedSearchType.id == 3) {
                if (folderIdNotNull || fromDateNotNull || toDateNotNull || registerItemIdNotNull) {
                    if (folderIdNotNull) {
                        filter += startOption + globalResources.Chapter + colon + vm.folderName;
                    }
                    else {
                        filter += startOption;
                    }

                    if (fromDateNotNull && folderIdNotNull) {
                        filter += seperator + globalResources.From + colon + getDateStringFromInput(vm.fromDateDisplayed);
                    }
                    else if (fromDateNotNull) {
                        filter += globalResources.From + colon + getDateStringFromInput(vm.fromDateDisplayed);
                    }

                    if ((toDateNotNull && folderIdNotNull) || (toDateNotNull && fromDateNotNull)) {
                        filter += seperator + globalResources.To + colon + getDateStringFromInput(vm.toDateDisplayed) + endOption;
                    }
                    else if (toDateNotNull) {
                        filter += globalResources.To + colon + getDateStringFromInput(vm.toDateDisplayed) + endOption;
                    }
                    else {
                        filter += endOption;
                    }
                }
            } else if ($scope.selectedSearchType.id == 4) {
                if (folderIdNotNull || registerItemIdNotNull) {
                    if (folderIdNotNull) {
                        filter += startOption + globalResources.Chapter + colon + vm.folderName;
                    }
                    else {
                        filter += startOption;
                    }

                    if (registerItemIdNotNull) {
                        filter += seperator + globalResources.Metadata + colon + vm.selectedItem.selectedMetadata.name;
                    }

                    if (registerItemValueIdNotNull) {
                        filter += seperator + globalResources.Tag + colon + vm.selectedItem.selectedTag.registerValue + endOption;
                    }
                    else {
                        filter += endOption;
                    }
                }
            }

            return filter;
        };

        function loadFolderTree() {
            // Does not follow config showDocumentInTree
            $http.get(handbookRequests.GetFoldersRequest, { params: { 'id': null, 'showDocumentInTree': false } })
                .success(function (data, status, headers, config) {
                    $scope.folderTree = data;
                    if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.folder))
                        loadSearchType();
                });
        }

        function loadAreaTree() {
            $http.get('/api/ProcessAreas/GetContent', { params: { AreaId: null, ShowProcessesInTree: false, IsOnlyApproved: false } })
                .success(function (data, status, headers, config) {
                    $scope.areaTree = data.areas;
                    if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.processArea))
                        loadSearchType();
                });
        }

        function loadSearchType() {
            if (vm.type == parseInt(E.searchTypeHandbook.advancedSearch)) {
                $scope.searchPlaceHolder = $scope.translation.AdvanceSearch;
                $scope.selectedSearchType = $scope.searchTypes[2];
                $scope.keyword = vm.keyword;
                $scope.fromDate = vm.fromDateDisplayed;
                $scope.toDate = vm.toDateDisplayed;
                $scope.hasExpired = vm.hasExpired;
                if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.folder)) {
                    for (var i = 0; i < $scope.folderTree.length; i++) {
                        if (vm.folderId == $scope.folderTree[i].id) {
                            $scope.selectedNode = $scope.folderTree[i];
                            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;
                            break;
                        }
                    }
                }
                else if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.processArea)) {
                    for (var i = 0; i < $scope.areaTree.length; i++) {
                        if (vm.folderId == $scope.areaTree[i].id) {
                            $scope.selectedNode = $scope.areaTree[i];
                            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;
                            break;
                        }
                    }
                }

                $scope.isAdvanceSearch = true;
                $scope.isMetadataSearch = false;
            } else if (vm.type == parseInt(E.searchTypeHandbook.contentSearch)) {
                $scope.searchPlaceHolder = $scope.translation.ContentSearch;
                $scope.selectedSearchType = $scope.searchTypes[1];
                $scope.keyword = vm.keyword;
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = false;
            } else if (vm.type == parseInt(E.searchTypeHandbook.titleSearch)) {
                $scope.searchPlaceHolder = $scope.translation.TitleSearch;
                $scope.selectedSearchType = $scope.searchTypes[0];
                $scope.keyword = vm.keyword;
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = false;
            } else if (vm.type == parseInt(E.searchTypeHandbook.metadataSearch)) {
                $scope.searchPlaceHolder = $scope.translation.MetadataSearch;
                $scope.keyword = vm.keyword;
                $scope.selectedSearchType = $scope.searchTypes[3];
                $scope.isAdvanceSearch = false;
                $scope.isMetadataSearch = true;
                if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.folder)) {
                    for (var i = 0; i < $scope.folderTree.length; i++) {
                        if (vm.folderId == $scope.folderTree[i].id) {
                            $scope.selectedNode = $scope.folderTree[i];
                            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;
                            break;
                        }
                    }
                }
                else if (vm.advancedSearchLocationType == parseInt(E.advancedSearchLocationType.processArea)) {
                    for (var i = 0; i < $scope.areaTree.length; i++) {
                        if (vm.folderId == $scope.areaTree[i].id) {
                            $scope.selectedNode = $scope.areaTree[i];
                            vm.folderName = $scope.selectedNode != null ? $scope.selectedNode.name : null;
                            break;
                        }
                    }
                }
                initMetadataSearch();
            }
            $timeout(function () {
                vm.searchFilter = getSearchFilter();
            }, 700);
        }

        function initMetadataSearch() {
            if (vm.registerItemId && vm.registerItemId != 0) {
                //getRegisterItems();
                getMetadataTags(vm.registerItemId);


                $timeout(function () {
                    if (vm.registerItemId && vm.registerItemId != 0) {
                        for (var i = 0; i < vm.initMetadata.metadatas.length; i++) {
                            var metadata = vm.initMetadata.metadatas[i];
                            if (vm.registerItemId == metadata.registerItemId) {
                                vm.selectedItem.selectedMetadata = metadata;
                                break;
                            }
                        }
                        if (vm.registerItemValueId && vm.registerItemValueId != 0) {
                            for (var i = 0; i < vm.initMetadata.tags.length; i++) {
                                var tag = vm.initMetadata.tags[i];
                                if (vm.registerItemValueId == tag.registerItemValueId) {
                                    vm.selectedItem.selectedTag = tag;
                                    break;
                                }
                            }
                        }
                        vm.startMetadata = 1;
                        vm.startTag = 1;
                    }
                }, 500);
            }
        };

        function onRowClick($event) {
            favoriteService.setFavoriteNodeState({
                isFavorited: false
            });
            documentService.goToDocument($event);
        };

        function loadByMaxSearchSize() {
            vm.loadMoreClickedCounter = 1;
            getSearchResult(E.searchType.Maximum);
        };

        function showLoadMoreLink(row) {
            var _isShow = vm.documents.length < vm.totalFound && vm.loadMoreClickedCounter == 0;
            var _isLastIndex = row.rowIndex == vm.documents.length - 1;

            if (_isShow && _isLastIndex) {
                return true;
            }
            return false;
        };

        function getDateStringFromInput(date) {
            return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
        }

        function updateAttachmentsForDocuments(documents) {
            var documentIds = [];
            for (var i = 0; i < documents.length; i++) {
                if (documents[i].hasAttachment) {
                    documentIds.push(documents[i].id);
                }
            }
            if (documentIds.length > 0) {
                $http
                    .post('/api/Documents/GetAttachmentsForDocuments', { documentIds: documentIds })
                    .success(function (data) {
                        if (data && data.length > 0) {
                            data.forEach(function (x) {
                                x.itemId = x.extraId ? x.extraId : x.itemId;
                            });
                        }
                        for (var i = 0; i < documents.length; i++) {
                            if (documents[i].hasAttachment) {
                                documents[i].attachments = [];
                                for (var j = 0; j < data.length; j++) {
                                    if (data[j].documentId == documents[i].id) {
                                        documents[i].attachments.push(data[j]);
                                    }
                                }
                            }
                        }
                    });
            }
        }

        function updateAttachmentsForProcesses(processes) {
            if (processes == null || processes.length == 0) {
                return processes;
            }

            var processEntityIds = [];
            for (var i = 0; i < processes.length; i++) {
                if (processes[i].hasAttachment && processes[i].isProcess) {
                    processEntityIds.push(processes[i].entityId);
                }
            }
            if (processEntityIds.length > 0) {
                $http.get('/api/Processes/GetAttachmentsForProcesses', {
                    params: { processEntityIds },
                })
                    .success(function (data) {
                        if (data && data.length > 0) {
                            data.forEach(x => {
                                x.itemId = x.extraId ? x.extraId : x.itemId;
                            });
                        }
                        for (var i = 0; i < processes.length; i++) {
                            if (processes[i].hasAttachment) {
                                processes[i].attachments = [];
                                processes[i].attachmentHtml = '';
                                for (var j = 0; j < data.length; j++) {
                                    if (data[j].processEntityId === processes[i].entityId) {
                                        processes[i].attachments.push(data[j]);
                                    }
                                }
                            }
                        }
                    });
            }

        }

        function updateAttachmentsForProcessesInterconnected(processesInterconnected) {
            if (processesInterconnected == null || processesInterconnected.length == 0) {
                return processesInterconnected;
            }

            var processInterconnectedEntityIds = [];
            for (var i = 0; i < processesInterconnected.length; i++) {
                if (processesInterconnected[i].hasAttachment && processesInterconnected[i].isProcess) {
                    processInterconnectedEntityIds.push(processesInterconnected[i].processInterconnectedEntityId);
                }
            }
            if (processInterconnectedEntityIds.length > 0) {
                $http.get(handbookRequests.GetAttachmentsForProcessesInterconnected, {
                    params: { processInterconnectedEntityIds },
                })
                    .success(function (data) {
                        if (data && data.length > 0) {
                            data.forEach(x => {
                                x.itemId = x.extraId ? x.extraId : x.itemId;
                            });
                        }
                        for (var i = 0; i < processesInterconnected.length; i++) {
                            if (processesInterconnected[i].hasAttachment) {
                                processesInterconnected[i].attachments = [];
                                processesInterconnected[i].attachmentHtml = '';
                                for (var j = 0; j < data.length; j++) {
                                    if (data[j].processInterconnectedEntityId === processesInterconnected[i].processInterconnectedEntityId) {
                                        processesInterconnected[i].attachments.push(data[j]);
                                    }
                                }
                            }
                        }
                    });
            }

        }

        //function calculateRemainingHeightForDocumentGrids() {
        //    var heightOfTopBar = $('#handbook-nav').outerHeight(true);
        //    var heightOfBreadcrumbs = $('.search-result-page > .clearfix').outerHeight(true);
        //    var heightOfSearchButtons = $('.search-result-page > .button-group').outerHeight(true);
        //    var heightOfSearchForm = $('.search-result-page > .form-button').outerHeight(true);
        //    var heightOfAdvancedSearchForm = $scope.isAdvanceSearch ? $('.search-result-page .search-result-search-more').outerHeight(true) : 0;
        //    var heightOfHandbookDocumentsTitle = $('.search-result-page .search-document-title-hit').outerHeight(true);
        //    var heightOfCompendiaDocumentsTitle = !showCompendiaSearch
        //        ? 0 : $('.search-result-page .compendia-title-hit').outerHeight(true);
        //    var heightOfFolderSearchTitle = !showFolderSearch
        //        ? 0 : $('.search-result-page .search-folder-title-hit').outerHeight(true);

        //    return $(window).height() - heightOfTopBar - heightOfBreadcrumbs
        //        - heightOfSearchButtons - heightOfSearchForm - heightOfAdvancedSearchForm
        //        - heightOfHandbookDocumentsTitle
        //        - heightOfCompendiaDocumentsTitle
        //        - heightOfFolderSearchTitle;
        //}


        function setHeightForGrid() {
            $timeout(function () {
                var filter = $('.advanced-search-more').height();
                if (Number(filter) > 0) {
                    vm.maxHeight = 570;
                } else {
                    vm.maxHeight = 635;
                }
                calculateHeightForDocumentGrids();
            }, 100);
        }

        function calculateHeightForDocumentGrids() {
            $('.handbook-folders #gridController tbody').css('max-height', vm.maxHeight);
            $('.compendia-documents .content-wrapper').css('max-height', vm.maxHeight);
            $('.handbook-documents #gridController tbody').css('max-height', vm.maxHeight);
        }

        function insertLogWords(documentId, employeeId, searchKey, searchType) {
            if (!vm.doSearchDataMining) {
                return;
            }

            vm.searchFilters = window.location.search;
            if (vm.searchFilters && vm.searchFilters != '') {
                if (documentId == -2) {
                    searchKey = decodeURI(vm.searchFilters.match("keyword=(.*)&search")[1]);
                    searchType = vm.searchFilters.substring(vm.searchFilters.length - 1);
                }

                return $http.post('/api/Search/LogSearchWords',
                    {
                        documentId: documentId,
                        employeeId: employeeId,
                        searchKey: searchKey,
                        searchType: searchType,
                        searchFilters: vm.searchFilters
                    }).then(function (data, status, headers, config) {
                        return true;
                    });
            }
        }

        function onVARClick(row) {
            window.open(row.url);
        }

        function triggerSearchVAR(keyword, offset) {
            if (vm.isLoadingVar) return;
            vm.isLoadingVar = true;

            return $http.get('/api/var/', {
                params: {
                    method: 'PROCEDURE',
                    query: keyword,
                    offset: offset
                }
            }).then(response => {
                if (!response || !response.data || !response.data.documents || !response.data.documents.length) return;
                vm.numFoundOfVar = response.data.numFound;
                vm.varRecords = [...vm.varRecords, ...(response.data.documents || [])];
                vm.VAROffset += response.data.documents.length;
                vm.varRecords.forEach(record => {
                    record.status = inferVarRecordStatus(record.changeType);
                    record.updatedDate = $filter('date')(record.lastUpdated, 'dd.MM.yyyy');
                });
            }).finally(() => {
                vm.isLoadingVar = false;
            });       
        }

        function inferVarRecordStatus(changeType) {
            if (!changeType) return '';
            changeType = changeType.toLowerCase();
            const prefix = window.resources.L.Common.degree.toUpperCase();
            switch (changeType) {
                case 'none': return `${prefix}: 0`;
                case 'insignificant': return `${prefix}: 1`;
                case 'small': return `${prefix}: 2`;
                case 'medium': return `${prefix}: 3`;
                case 'large': return `${prefix}: 4`;
                case 'new': return `${prefix}: ${window.resources.L.Common.new}`;
                default: return '';
            }
        }
         
        function watchVARGridScroll() {
            $('#searchVAR').bind('scroll', (event) => {
                var element = event.target;
                if ($(element).scrollTop() + $(element).innerHeight() >= $(element)[0].scrollHeight) {
                    const quickSearchKeyword = vm.keyword ? vm.keyword.trim() : '';
                    triggerSearchVAR(quickSearchKeyword, vm.VAROffset).then(() => {
                        broadcastService(broadcastType.gridDataChanges, { id: 'searchVAR', data: vm.varRecords, isForced: true });
                    });
                }
            });
        }

        function isGuid(char) {
            return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi.test(char);
        }

        function getExportParams() {
            if (vm.processes.length) {
                vm.enableExportButton = true;
                setProcessExportParams();
            }
            else if (vm.documents.length) {
                vm.enableExportButton = true;
                setDocumentExportParams();
            } else if (vm.processesInterconnected.length) {
                vm.enableExportButton = true;
                setProcessInterconnectedExportParams();
            }
        }

        function generateSearchProcessParams(searchType) {
            return {
                keyword: vm.keyword ? vm.keyword : '',
                searchType: searchType,
                isFrontend: true,
                isContentSearch: vm.searchInContents
            };
        }

        function generateSearchProcessAdvanceParams(keyword, searchType) {
            var fromDate = null;
            if (vm.fromDateBK != null && typeof vm.fromDateBK != 'string') {
                fromDate = vm.fromDateBK.toUTCString().replace('UTC', 'GMT');
            }
            var toDate = null;
            if (vm.toDateBK != null && typeof vm.toDateBK != 'string') {
                toDate = vm.toDateBK.toUTCString().replace('UTC', 'GMT');
            }

            return {
                keyword: keyword,
                isContentSearch: vm.searchInContents ? true : false,
                areaId: vm.folderId,
                metadataMustContainAll: vm.type == parseInt(E.searchTypeHandbook.metadataSearch),
                myProcessOnly: false,
                processStatusApprovalFilter: E.advancedSearchApprovalProcessStatus.Approved,
                fromDate: fromDate,
                toDate: toDate,
                searchType: searchType,
                registerItemId: vm.registerItemId,
                registerItemValueId: vm.registerItemValueId,
                dateFilter: 4,
                hasQuit: false,
                hasQuitApprove: false,
                includeSubAreas: vm.type == parseInt(E.searchTypeHandbook.advancedSearch) || vm.type == parseInt(E.searchTypeHandbook.metadataSearch),
                includeVirtualProcesses: true,
                isFrontend: true,
            }
        }

        function generateExportParams() {
            vm.filter = {
                keyword: vm.keyword,
                searchInContents: vm.searchInContents,
                searchType: E.searchType.Maximum,
                folderId: vm.folderId,
                fromDate: vm.fromDate,
                toDate: vm.toDate,
                hasExpired: vm.hasExpired,
                registerItemId: vm.registerItemValueId != null ? null : vm.registerItemId,
                registerItemValueId: vm.registerItemValueId,
                advancedSearchLocationType: vm.advancedSearchLocationType,
                version: vm.version,
                documentType: vm.documentType
            };

            vm.exportDocumentParams = {
                folderId: vm.folderId,
                isRecursive: false,
                groupBy: E.exportDocumentGroupsByColumn.none,
                filter: vm.filter
            };
            vm.exportDocumentParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Document);

            if (vm.type == E.searchTypeHandbook.titleSearch || vm.type == E.searchTypeHandbook.contentSearch) {
                vm.searchProcessParams = generateSearchProcessParams(E.searchType.Maximum);
            } else if (vm.type == E.searchTypeHandbook.advancedSearch || vm.type == E.searchTypeHandbook.metadataSearch) {
                vm.searchProcessParams = generateSearchProcessAdvanceParams(vm.keyword, E.searchType.Maximum);
            }

            vm.exportProcessParams = {
                filter: vm.searchProcessParams,
                columns: getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Process)
            };
            vm.exportProcessInterconnectedParams = {
                filter: vm.searchProcessParams,
                columns: getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.InterconnectedProcess)
            };
        }

        function setDocumentExportParams() {
            vm.exportParams = vm.exportDocumentParams;
            vm.exportRequestUrl = vm.handbookRequests.ExportSearchedDocuments;
        }

        function setProcessExportParams() {
            vm.exportParams = vm.exportProcessParams;
            if (vm.type == E.searchTypeHandbook.titleSearch || vm.type == E.searchTypeHandbook.contentSearch) {
                vm.exportRequestUrl = vm.handbookRequests.ExportSearchedProcesses;
            }
            else if (vm.type == E.searchTypeHandbook.advancedSearch || vm.type == E.searchTypeHandbook.metadataSearch) {
                vm.exportRequestUrl = vm.handbookRequests.ExportSearchedProcessesAdvance;
            }
        }

        function setProcessInterconnectedExportParams() {
            vm.exportParams = vm.exportProcessInterconnectedParams;
            if (vm.type == E.searchTypeHandbook.titleSearch || vm.type == E.searchTypeHandbook.contentSearch) {
                vm.exportRequestUrl = vm.handbookRequests.ExportSearchedProcessesInterconnected;
            }
            else if (vm.type == E.searchTypeHandbook.advancedSearch || vm.type == E.searchTypeHandbook.metadataSearch) {
                vm.exportRequestUrl = vm.handbookRequests.ExportSearchedProcessesInterconnectedAdvance;
            }
        }

        function handleChangeTabForExportList(activeTab) {
            vm.enableExportButton = true;
            switch (activeTab) {
                case vm.tabNameToExport.processTab:
                    setProcessExportParams();
                    break;
                case vm.tabNameToExport.documentTab:
                    setDocumentExportParams();
                    break;
                case vm.tabNameToExport.interconnectedTab:
                    setProcessInterconnectedExportParams();
                    break;

                default:
                    vm.enableExportButton = false;
                    break;
            }
        }
    }
})();